export default {
  components: {
    workflowSelector: {
      placeholder: 'Please select workflow',
      fetchFailed: 'Failed to fetch workflow list',
    },
    workflowVersionPanel: {
      title: 'Version',
      filter: {
        all: 'All',
        onlyMy: 'Only My Submissions',
        onlyPublished: 'Published Only',
      },
      loading: 'Loading...',
      deprecated: 'Deprecated',
      placeholder: 'Please enter version name',
      actions: {
        publish: 'Publish',
        publishBind: 'Publish & Bind',
        viewConfig: 'View Config',
        loadToCurrent: 'Load to Current',
        deprecate: 'Deprecate',
        delete: 'Delete',
      },
      empty: 'No version data available',
      deprecateModal: {
        title: 'Deprecate Version',
        alert:
          'After deprecating, protocols cannot be bound to this version and it cannot be recovered.',
        reason: 'Reason',
        reasonPlaceholder: 'Please enter the reason for deprecation',
      },
      message: {
        fetchFailed: 'Failed to load version list',
        loadSuccess: 'Successfully loaded version {version}',
        loadFailed: 'Failed to import version',
        deprecateConfirm: 'Please enter deprecation reason',
        deprecateFailed: 'Failed to deprecate version',
      },
      deprecateDisableHint:
        'This version is bound by {protocols} and cannot be deprecated',
    },
    workflowEntryInput: {
      label: 'Workflow Execution Params',
      mode: {
        keyValue: 'Key-Value Mode',
        json: 'JSON Mode',
      },
      importExample: 'Import Example Config',
      exampleConfig: 'Example Config',
      placeholder: 'Please select example config to import',
      message: {
        jsonMustBeObject:
          'JSON data must be an object to switch to Key-Value mode',
        jsonFormatError: 'JSON format error, cannot switch to Key-Value mode',
        importSuccess: 'Example config imported successfully',
        fetchFailed: 'Failed to load example config',
      },
    },
    variableInput: {
      triggerHint: 'Type $ to select variables from previous nodes',
    },
    workflowToSchemaModal: {
      title: 'Import Data Structure from Workflow',
      selectWorkflow: 'Select Workflow',
      entryNodeInfo: 'Entry Node Information',
      nodeName: 'Node Name:',
      nodeType: 'Node Type:',
      outputVars: 'Output Variables:',
      varCount: '{count} variable(s)',
      preview: 'Output Variables Preview',
      childrenCount: 'Contains {count} child variable(s)',
      importVars: 'Import Variables',
      message: {
        noEntry:
          'The workflow has no entry node or the entry node does not exist',
        defaultEntryName: 'Entry Node',
        noOutputVars:
          'The entry node of this workflow has no output variables defined',
        fetchDetailFailed: 'Failed to fetch workflow details',
        validate: 'Please select a workflow and ensure it has output variables',
        importSuccess: '{count} variable(s) imported successfully',
        importFailed: 'Failed to import variables',
      },
    },
    conversationItem: {
      noContent: 'No conversation content',
      noOptions: 'No options',
    },
    modal: {
      deleteConfirm: {
        title: 'Confirm Delete',
        okText: 'Delete',
        cancelText: 'Cancel',
      },
      resourceDelete: {
        title: 'Confirm Delete',
        okText: 'Delete',
        cancelText: 'Cancel',
        confirmContent: 'Are you sure you want to delete {name}?',
        inputLabel: 'Please enter {name} to confirm deletion:',
        placeholder: 'Please enter name to confirm',
        autoFill: 'Auto Fill',
        deleteFailed: 'Delete Failed',
      },
      versionConflict: {
        title: 'Version Conflict',
        notice: {
          title: 'New version submitted',
          desc: 'The workflow has been updated by others. Please choose how to process your draft.',
        },
        selectionTitle:
          'Please choose a version to overwrite the current draft:',
        options: {
          saveDraft: {
            title: 'My Draft',
            desc: 'Save your draft as a new version',
            tag: 'Editing',
            lastEdited: 'Last Edited:',
            editor: 'Edited By:',
          },
          latestVersion: {
            title: 'Latest Version',
            desc: 'Load latest version to draft, you can edit and save on it',
            tag: 'Published',
            updateTime: 'Updated At:',
            updater: 'Updated By:',
            viewDetail: 'View Details',
          },
        },
        actions: {
          confirm: 'Confirm',
          cancel: 'Cancel',
        },
        unknownTime: 'Unknown Time',
        unknownUser: 'Unknown',
      },
    },
    backendSelect: {
      label: 'Backend Service',
      currentService: 'Current Service',
    },
    columnsShowSelector: {
      title: 'Columns Display',
      columnName: 'Column Name',
    },
    cardList: {
      updatedAt: 'Updated At',
      empty: 'No Data',
    },
    catalogDrawer: {
      title: 'Quick Edit Catalog',
      tips: {
        title: 'Operation Tips:',
        dragToModify: '1. Drag workflow to catalog to modify catalog',
        dragToWorkflow:
          '2. Drag to workflow node to set catalog to target workflow catalog',
        emptyDelete: '3. Empty catalog will be deleted automatically',
      },
      addCatalog: {
        placeholder: 'Enter new catalog name, support multi-level e.g. a/b/c',
        button: 'Add Catalog',
      },
      tree: {
        emptyDropArea: 'Drag here to move to root catalog',
      },
      renameModal: {
        title: 'Rename Catalog',
        alert: {
          title: 'Operation Tips:',
          content:
            'This operation will affect all sub-catalogs and sub-workflows',
        },
        label: 'New Catalog Name',
        placeholder: 'Please enter new catalog name',
        required: 'Please enter new catalog name',
      },
      messages: {
        pathNotFound: 'Catalog path not found',
        enterName: 'Please enter new catalog name',
        renameSuccess: 'Catalog renamed successfully',
        updateFailed: 'Failed to update some workflow catalogs',
        addSuccess: 'Catalog added successfully',
        exists: 'Catalog already exists',
        dragWorkflowOnly: 'Only workflows can be dragged to catalog',
        moveToRootSuccess: 'Moved to root catalog',
        moveToRootFailed: 'Failed to move to root catalog',
        updateSuccess: 'Catalog updated successfully',
        updateCatalogFailed: 'Failed to update catalog',
        dragToCatalogOnly: 'Workflows can only be dragged into catalogs',
        dragToRootOnly: 'Only workflows can be dragged to root catalog',
      },
    },
    mysqlFormControl: {
      unsupportedDefault:
        'Default value configuration is not supported for this type',
      placeholder: {
        integer: 'Please enter integer',
        decimal: 'Please enter decimal',
        number: 'Please enter number',
        text: 'Please enter text',
        json: 'Please enter JSON data',
        datetime: 'Please select date and time',
        date: 'Please select date',
        time: 'Please select time',
        default: 'This field type does not support editing',
      },
      switch: {
        yes: 'Yes',
        no: 'No',
      },
    },
    backendUpdateModal: {
      title: 'Backend Service Update',
      label: 'Backend Service',
      placeholder: 'Please select backend service to update',
      rule: 'Please select service port',
      success:
        'Update {port} service successfully, please check corresponding service',
    },
    bindHistoryDrawer: {
      title: '{protocol} Binding History',
      columns: {
        description: 'Description',
        workflow: 'Bound Workflow',
        editor: 'Creator',
        createdAt: 'Created At',
      },
      noDescription: 'No Description',
    },
    deleteImpactModal: {
      title: 'Delete Node Impact Analysis',
      okText: {
        autoFix: 'Auto Fix & Delete',
        confirm: 'Confirm Delete',
      },
      loading: 'Analyzing...',
      sections: {
        affected: 'Affected Nodes',
        brokenEdges: 'Broken Connections',
        orphaned: 'Potential Orphaned Nodes',
        autoFixTitle: 'Auto Fix Available',
        autoFixContent:
          'System can automatically reconnect edges and update variable references to upstream nodes',
        noImpact: 'Deleting this node will not affect other nodes',
        reconnectTo: 'Auto reconnect to: {node}',
      },
      fallback:
        'Are you sure you want to delete this node? Related reference variables will be automatically removed.',
    },
    createKnowledgeModal: {
      title: {
        edit: 'Edit Knowledge Base',
        create: 'Create Knowledge Base',
      },
      okText: {
        saving: 'Saving...',
        save: 'Save',
      },
      form: {
        name: 'Knowledge Base Name',
        namePlaceholder: 'Please enter',
        desc: 'Knowledge Base Description',
        descPlaceholder: 'Please enter',
        embeddingModel: 'Embedding Model',
        selectPlaceholder: 'Please select',
        vectorDbType: 'Vector DB Type',
        metadata: 'Knowledge Base Metadata',
      },
      table: {
        key: 'Metadata Key',
        desc: 'Description',
        default: 'Default Value',
        required: 'Required',
        add: 'Add Field',
      },
      rules: {
        name: 'Please enter knowledge base name',
        nameLength: 'Knowledge base name must be between 2 and 30 characters',
        desc: 'Please enter knowledge base description',
        keyEmpty: 'Metadata key at row {row} cannot be empty',
        keyDuplicate: 'Duplicate metadata keys exist: {names}',
      },
    },
    createWorkflowModal: {
      title: {
        edit: 'Edit Workflow',
        copy: 'Clone Workflow',
        create: 'Create Workflow',
      },
      okText: {
        saving: 'Saving...',
        save: 'Save',
      },
      form: {
        name: 'Workflow Name',
        namePlaceholder: 'Please enter',
        desc: 'Workflow Description',
        descPlaceholder: 'Please enter',
        tags: 'Workflow Tags',
        tagsPlaceholder: 'Please select tags',
        catalog: 'Belonging Catalog',
        catalogPlaceholder:
          'Select existing catalog or enter new one, takes effect after save',
        recordLog: 'Execution Record Switch',
        errorBehavior: 'Error Handling',
        errorTooltip:
          'Stop Execution: Interrupts process when exception occurs; Continue Execution: Workflow continues remaining process; Remaining nodes result depends on whether they are affected by the exception node.',
        selectPlaceholder: 'Please select',
      },
      errorOptions: {
        stop: 'Stop Execution',
        continue: 'Continue Execution',
      },
      rules: {
        name: 'Please enter workflow name',
        nameLength: 'Workflow name must be between 2 and 30 characters',
        desc: 'Please enter workflow description',
      },
      copySuffix: '-Copy',
    },
    createWorkspaceModal: {
      title: 'Create Workspace',
      okText: {
        creating: 'Creating...',
        create: 'Create',
      },
      form: {
        name: 'Workspace Name',
        namePlaceholder: 'Enter workspace name',
        description: 'Description',
        descPlaceholder: 'Enter workspace description (optional)',
      },
      rules: {
        name: 'Workspace name is required',
        nameLength: 'Workspace name must be between 2 and 30 characters',
      },
      success: 'Workspace created successfully',
      error: 'Failed to create workspace',
    },
    emailVerification: {
      title: 'Email Verification',
      email: 'Email',
      emailPlaceholder: 'Enter workspace owner email',
      emailRequired: 'Please enter email',
      emailInvalid: 'Please enter a valid email address',
      code: 'Verification Code',
      codePlaceholder: 'Enter 6-digit verification code',
      codeRequired: 'Please enter verification code',
      codeInvalid: 'Verification code must be 6 digits',
      sendCode: 'Send Code',
      codeSent: 'Verification code sent to your email',
      sendCodeFail: 'Failed to send verification code, please try again',
      verifySuccess: 'Verification successful',
      verifyFail: 'Verification failed, please check the code',
    },
    executeWorkflowPanel: {
      title: 'Test Workflow',
      saveBeforeTest: 'Please save the workflow before testing',
      runningAlert: {
        title: 'Running the workflow',
        content1:
          'You can safely close this window and view the status and results in ',
        link1: 'Test Run Tasks',
        content2:
          ' after completion. To monitor execution in real time, click ',
        link2: 'Trace',
        content3: '.',
      },
      tabs: {
        input: 'Input',
        details: 'Details',
        trace: 'Trace',
      },
      aiGenerate: {
        tooltip: {
          noParams: 'Current workflow has no input parameters',
          generate: 'AI Smart Generate Test Data',
        },
        button: 'AI Generate',
        popover: {
          title: 'Describe test scenario (optional)',
          placeholder: 'e.g.: Test Chinese Q&A, test exception input...',
          generateButton: 'Generate Test Data',
        },
      },
      importExample: 'Import Example',
      noInputTip: 'No input variables',
      noRunData: 'No run data yet',
      viewLog: 'View Log',
      totalTokens: 'Total Tokens',
      testCase: {
        select: 'Select test case',
        add: 'Add test case',
        modalTitle: 'Add test case',
        name: 'Test case name',
        description: 'Test case description',
        inputVariables: 'Input Variables',
        saveWithRun: 'Save this run as a test case',
        nameRequired: 'Please enter a test case name',
        createSuccess: 'Test case created',
        createFailed: 'Failed to create test case',
      },
      subscription: {
        idle: 'Not Subscribed',
        connecting: 'Subscribing',
        connected: 'Subscribed',
        error: 'Subscription Error',
      },
      testButton: {
        testing: 'Testing...',
        start: 'Start Test',
      },
      triggerTestRun: {
        startNodeSelect: 'Select start node',
        startingTitle: 'Starting Trigger Test Run',
        starting: 'Starting the trigger test run session. Please wait...',
        listeningTitle: 'Trigger is listening',
        webhookListening:
          'You can now simulate event triggers by sending test requests to the HTTP Webhook Trigger endpoint or use it as a callback URL for live event debugging.',
        scheduleListening:
          'Listening for events from triggers... You can wait for the schedule trigger next execution time.',
        triggeredTitle: 'Trigger event received',
        triggered:
          'A trigger event was received. Preparing workflow execution...',
        nextRunAt: 'Next scheduled run: {time}',
        stoppedTitle: 'Trigger test run stopped',
        stopped: 'This trigger test run has been stopped.',
        errorTitle: 'Trigger test run error',
        stop: 'Stop Listening',
        stopSuccess: 'Trigger test run stopped',
        stopFailed: 'Failed to stop trigger test run',
        startFailed: 'Failed to start trigger test run',
        triggerUnavailable:
          'The selected trigger is not available yet. Please save or publish the workflow first.',
      },
      messages: {
        noParams: 'No parameters to fill',
        generateSuccess: 'Test data generated',
        generateFailed: 'AI generation failed',
        wsNotConnected: 'WebSocket not connected, please try again later',
        wsParseFailed: 'Failed to parse WebSocket message',
      },
      traceMedia: {
        title: 'Media Outputs',
        preview: 'Preview',
        download: 'Download',
        previewUnavailable: 'Preview unavailable',
        unknownFile: 'Media File',
        kind: {
          image: 'Image',
          video: 'Video',
          audio: 'Audio',
          file: 'File',
        },
      },
    },
    fieldRenderer: {
      inputPlaceholder: 'Please enter {field}',
      itemPlaceholder: 'Item {index}',
      itemLabel: 'Item {index}:',
      addItem: 'Add Item',
      addObject: 'Add Object',
      addKeyValue: 'Add Key-Value Pair',
      arrayObjectTitle: '{name} {index}',
      objectTitle: 'Object {index}',
      objectJsonPlaceholder: 'Please enter a JSON object',
      keyPlaceholder: 'Key',
      valuePlaceholder: 'Value',
      jsonFormatError: 'Invalid JSON format',
    },
    executeResults: {
      viewLog: 'View Log',
      input: 'Input',
      output: 'Output',
    },
    documentViewer: {
      type: {
        word: 'Word Document',
        pdf: 'PDF Document',
        excel: 'Excel Document',
        pptx: 'PowerPoint Document',
      },
      download: 'Download',
      downloadFile: 'Download File',
      noPreviewNote:
        'This format is not supported for online preview. Please download to view.',
      empty: 'No content',
    },
    fullscreenInputPanel: {
      code: 'Code',
      systemPrompt: 'System Prompt',
      userPrompt: 'User Prompt',
      prompt: 'User Prompt',
      exceptionHandle: 'Exception Handle',
    },
    debugSettings: {
      title: 'Debug Settings',
      workflowHttpBaseUrl: 'Workflow HTTP Base URL',
      workflowHttpBaseUrlPlaceholder: 'e.g.: http://localhost:8080',
      workflowCopilotWsPort: 'Workflow Copilot WS Port',
      workflowCopilotWsPortPlaceholder: 'e.g.: 8081',
      workflowExecutionWsPort: 'Workflow Execution WS Port',
      workflowExecutionWsPortPlaceholder: 'e.g.: 8082',
      saveSuccess: 'Debug settings saved',
      saveFailed: 'Save failed',
    },
    feedbackBot: {
      wishlist: {
        tab: 'Wishlist',
        title: 'Make a Wish ✨',
        contentLabel: 'What feature do you want?',
        contentPlaceholder:
          "Describe the feature or improvement you'd like to see...",
        contactLabel: 'Contact (optional)',
        contactPlaceholder: 'Email for follow-up',
        submit: 'Submit Wish',
        success: 'Your wish is recorded! We will take it seriously ✨',
      },
      feedback: {
        tab: 'Feedback',
        title: 'Report an Issue 🐛',
        typeLabel: 'Issue Type',
        typePlaceholder: 'Select issue type',
        types: {
          bug: 'Bug / Error',
          ui: 'UI / Display',
          performance: 'Performance',
          other: 'Other',
        },
        contentLabel: 'Describe the issue',
        contentPlaceholder:
          'Steps to reproduce, expected vs actual behavior...',
        contactLabel: 'Contact (optional)',
        contactPlaceholder: 'Email for follow-up',
        submit: 'Submit Feedback',
        success: 'Thank you for your feedback! We will handle it ASAP 🙌',
      },
      required: 'This field is required',
    },
  },
};
